import {Color} from '$constants/style';
import theme from '$modules/booking/theme';

export const containerStyles = {
  backgroundColor: Color.SidebarMain,
  minHeight: '100vh',
  width: '100%',
  maxWidth: '100% !important',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: '16px 40px 36px',
  fontFamily: "'Inter Variable', sans-serif",
  overflow: 'auto',
};

export const contentWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
};

export const backButtonStyles = {
  maxWidth: '80px',
  width: '100%',
  height: '24px',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 400,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '27px 27px',
  color: Color.Purple600,
  '&:hover': {
    backgroundColor: Color.Primary2Main,
  },
};

export const headerTitleStyles = {
  color: Color.Purple600,
  fontWeight: 600,
  fontSize: '24px',
  padding: '12px 0',
};

export const summaryContainerStyles = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  alignItems: 'center',
  marginBottom: 3,
  gap: '24px',
  padding: '16px 0 40px',
};

export const summaryBoxStyles = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  width: '181px',
  minHeight: '80px',
  alignItems: 'flex-start',
  gap: '9px',
};

export const summaryLabelStyles = {
  color: Color.TextPrimary,
  fontSize: '14px',
  fontWeight: 400,
};

export const centeredSummaryValueStyles = {
  width: '100%',
  margin: 'auto 0',
};

export const summaryValueStyles = {
  color: Color.Grey500,
  fontSize: '32px',
  fontWeight: 600,
  ...centeredSummaryValueStyles,
};

export const summarySmallValueStyles = {
  color: Color.Grey500,
  fontSize: '16px',
  fontWeight: 600,
  ...centeredSummaryValueStyles,
};

export const verticalDividerStyles = {
  borderColor: Color.Grey300,
};

export const paymentMethodContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  ...centeredSummaryValueStyles,
};

export const cardIconStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '& svg': {
    width: '50px',
    height: '24px',
  },
};

export const sectionTitleStyles = {
  fontSize: '24px',
  fontWeight: 600,
  color: Color.Purple600,
  marginBottom: 2,
  lineHeight: '28px',
  padding: '16px 0 16px',
};

export const detailsContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  paddingBottom: '40px',
};

export const detailsRowStyles = {
  display: 'flex',
  flexDirection: 'row',
  gap: '67px',
};

export const detailsColumnStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
};

export const detailsLabelStyles = {
  fontSize: '14px',
  fontWeight: 400,
  color: Color.TextPrimary,
};

export const detailsValueStyles = {
  fontSize: '16px',
  fontWeight: 600,
  color: Color.TextPrimary,
};

export const GenerateInvoiceButtonWrapperStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  margin: '0 20px 20px 0',
};

export const GenerateInvoiceButtonStyles = {
  textTransform: 'none',
  color: Color.Purple600,
  border: '1px solid #ccc',
  backgroundColor: `${Color.White} !important`,
};

export const bookingPaymentTitleStyles = {
  mt: '15px',
  mb: '8px',
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: '24px',
  lineHeight: '28px',
  letterSpacing: '-0.0075em',
  color: '#4A168C',
};

export const takePaymentButtonStyles = {
  height: '40px',
};

export const actionButtonsContainerStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  mt: 2,
};

export const modalContentStyles = {
  p: 2,
  minWidth: 320,
};

export const modalTitleStyles = {
  fontWeight: 600,
  mb: 1,
  fontSize: '24px',
};

export const modalDescriptionStyles = {
  fontSize: '16px',
  fontWeight: 400,
  fontFamily: 'Inter',
};

export const modalActionsStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 2,
  mt: 3,
};

export const cancelRedButtonStyles = {
  color: '#d92d20 !important',
  borderColor: '#d92d20 !important',
};

export const dropdownFormControlStyles = {
  width: 320,
  height: 48,
  borderRadius: 2,
  background: '#fff',
  '& .MuiOutlinedInput-root': {
    borderRadius: 2,
    height: 48,
    background: '#fff',
    borderColor: '#BCA7E6',
    '& fieldset': {
      borderColor: '#BCA7E6',
    },
    '&:hover fieldset': {
      borderColor: '#7625DC',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#7625DC',
    },
  },
};

export const dropdownLabelTypographyStyles = {
  fontWeight: 400,
  fontSize: 14,
  mb: 0.5,
  lineHeight: '18px',
  color: '#101828',
  letterSpacing: 0.75,
};

export const modalBoxStyles = {
  p: 2,
  minWidth: 320,
};

export const modalTitleTypographyStyles = {
  fontWeight: 600,
  mb: 1,
  fontSize: '24px',
};

export const modalDescriptionTypographyStyles = {
  fontSize: '16px',
  fontWeight: 400,
  fontFamily: 'Inter',
};

export const modalActionsBoxStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 2,
  mt: 3,
};

export const iconContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '56px',
  height: '56px',
  borderRadius: '16px',
  opacity: '60%',
  background: '#d9daff',
};

export const paymentSuccessTitleStyles = {
  mb: 1,
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: '24px',
  lineHeight: '28px',
  letterSpacing: '-0.0075em',
  textAlign: 'center',
  mt: '18px',
};

export const paymentSuccessSubtitleStyles = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '22px',
  letterSpacing: '-0.0075em',
  textAlign: 'center',
  color: '#475467',
  mt: '12px',
};

export const paymentSuccessSubtitle2Styles = {
  mb: 3,
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '22px',
  letterSpacing: '-0.0075em',
  textAlign: 'center',
  color: '#475467',
  width: '456px',
};

export const paymentSuccessButtonRowStyles = {
  display: 'flex',
  gap: '8px',
  mt: '16px',
};

export const paymentSuccessOuterBoxStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '70vh',
  width: '100%',
};

export const paymentSuccessBackButtonExtraStyles = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  marginBottom: '26px',
};

export const subtitleTypographyStyles = {
  mb: 2,
  color: 'text.secondary',
};

export const invoiceDetailsBoxStyles = {
  mb: 2.5,
  mt: '8px',
};

export const paymentMethodBoxStyles = {
  gap: '8px',
  mt: '38px',
  display: 'flex',
  flexDirection: 'column',
};
export const errorMessageStyles = {
  color: theme.palette.error.main,
  fontSize: '0.875rem',
  marginTop: '16px',
  textAlign: 'center',
};
